export default [
  {
    text: 'Мостовой кран',
    value: 'overhead',
  },
  {
    text: 'Кран-балка',
    value: 'beam',
  },
  {
    text: 'Ж/д кран',
    value: 'railway',
  },
  {
    text: 'Козловой кран',
    value: 'gantry',
  },
];
